import styled, { css } from 'styled-components';

import { InputAppearance } from './Input';

import { Color } from '../../../shared/constants/Colors';
import {
  FontSize,
  FontType,
  FontWeight,
} from '../../../shared/constants/Fonts';
import { Transition } from '../../../shared/constants/Styles';

export const InputContainer = styled.div``;

export const StyledLabel = styled.label`
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.REGULAR};
  color: ${({ hasError }) => (hasError ? Color.RED : Color.BLACK)};
  align-self: center;
  margin-bottom: 6px;
  display: inline-block;
`;

export const StyledField = css`
  width: 100%;
  display: flex;
  flex-grow: 1;
  padding: ${props =>
    props.icon ? '9.5px 12px 9.5px 52px' : '9.5px 12px 9.5px 24px'};
  margin: 0
  box-sizing: border-box;
  border-radius: 22.5px;
  color: ${Color.CLOUD_BURST};
  font-family: ${FontType.PRIMARY};
  font-size: ${FontSize.M};
  background-color: transparent;
  letter-spacing: 0;
  line-height: 22px;
  outline: none;
  border: ${({ appearance, hasError }) =>
    appearance === InputAppearance.PRIMARY
      ? 'none'
      : hasError
      ? `2px solid ${Color.RED}`
      : `2px solid ${Color.MYSTIC}`};
  
  &::placeholder {
    color: ${Color.DOLPHIN};
  }

  &:disabled {
    background-color: ${Color.MYSTIC}
  }

  &:focus-visible {
      border: ${({ appearance, hasFocus, hasError }) =>
        appearance === InputAppearance.PRIMARY && !hasFocus
          ? 'none'
          : hasError
          ? `2px solid ${Color.RED}`
          : `2px solid ${Color.CLOUD_BURST}`};
  }
`;

export const InputField = styled.input`
  ${StyledField}
`;

export const TextAreaField = styled.textarea`
  ${StyledField}
  min-height: 45px;
`;

export const StyledInput = styled.div`
  align-items: center;
  position: relative;
  cursor: text;
  display: flex;
  flex-direction: row;
  min-height: 45px;
  border-radius: 22.5px;
  box-sizing: border-box;
  background-color: ${Color.WHITE};
  transition: ${Transition.ALL_EASE};

  svg {
    display: flex;
    position: absolute;
    top: 14px;
    left: 24px;
    flex-shrink: 0;
    height: 15px;
    width: 15px;
    color: ${Color.CLOUD_BURST};
    padding-right: 13px;
  }
`;
